import Gateway from '@tencent/gateway-vision-sdk';
import { config } from 'lib/config';
import { ENV } from 'lib/constants/domain';
import { ATTA_GATEWAY_MOBILE } from 'lib/constants/atta';
import msdkUtil from '../MSDK';
import { report } from '../dataReport';

interface GatewayOptions {
  channelId: string;
  enableJsBridge: boolean;
}

class GatewayObject {
  public mobileToken: string | undefined;
  private gateway: Gateway;

  public initGatewayMobile({ channelId, enableJsBridge }: GatewayOptions) {
    const isMsdk = msdkUtil.isMSDKEnv;
    this.gateway = new Gateway({
      appId: channelId,
      isTest: config.env !== ENV.PRODUCTION && config.env !== ENV.GRAY,
      enableMSDKCall: !!(isMsdk && enableJsBridge), // msdk中才能使用jsbridge
    });
  }

  public async getMaskMobile() {
    if (!this.gateway) return;
    try {
      const { mobile_data: data } = await this.gateway.getMobile();
      report(ATTA_GATEWAY_MOBILE.MASK_MOBILE_RESULT, {
        eventResult: !!data?.mask_mobile ? 0 : -1,
      });
      return data?.mask_mobile;
    } catch (error) {
      console.error('getMaskMobile error', error);
      return;
    }
  }

  public async getMobileToken() {
    if (!this.gateway) return;
    if (this.mobileToken) {
      return this.mobileToken;
    }
    try {
      const { token } = await this.gateway.gatewayLogin();
      report(ATTA_GATEWAY_MOBILE.MOBILE_TOKEN_RESULT, {
        eventResult: !!token ? 0 : -1,
      });
      return (this.mobileToken = token);
    } catch (error) {
      console.error('getMobileToken error', error);
      return;
    }
  }
}

const gateway = new GatewayObject();
export { gateway };
